<button mat-icon-button (click)="toggle()"
        [attr.aria-label]="'appSettings.darkTheme' | translate"
        [attr.aria-pressed]="darkTheme()"
        [title]="'appSettings.darkTheme' | translate">
  <mat-icon>{{ darkTheme() ? 'light_mode' : 'dark_mode' }}</mat-icon>
</button>
